import { EntityModel } from '@/interfaces'
import {
  ALL_BOOKING_DISCOUNTS_QUERY,
  CREATE_BOOKING_DISCOUNT_MUTATION,
  DELETE_BOOKING_DISCOUNT_MUTATION,
  FORCE_DELETE_BOOKING_DISCOUNT_MUTATION,
  SINGLE_BOOKING_DISCOUNT_QUERY,
  UPDATE_BOOKING_DISCOUNT_MUTATION,
} from './graphql'
import travelPricingMandatorySettingsEntity from '@/entities/travelPricingMandatorySettings/entity'

const ratioBookingDiscountModel: EntityModel = {
  name: 'bookingDiscount',
  namePlural: 'bookingDiscounts',
  uniqueName: 'ratioBookingDiscount',
  uniqueNamePlural: 'ratioBookingDiscounts',
  path: 'travel/pricing/adaptors/ratio/booking_discount',
  baseUrl: '/travel/pricing/adaptors/ratio/booking_discounts',
  translationPrefix: 'entities:ratioBookingDiscount.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_BOOKING_DISCOUNTS_QUERY,
    getSingle: SINGLE_BOOKING_DISCOUNT_QUERY,
    create: CREATE_BOOKING_DISCOUNT_MUTATION,
    update: UPDATE_BOOKING_DISCOUNT_MUTATION,
    delete: DELETE_BOOKING_DISCOUNT_MUTATION,
    forceDelete: FORCE_DELETE_BOOKING_DISCOUNT_MUTATION,
  },
  attributes: {
    ratioServiceNo: {
      name: 'ratioServiceNo',
      label: 'entities:ratioBookingDiscount.attributes.ratioServiceNo.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [],
    },
    name: {
      name: 'name',
      label: 'entities:ratioBookingDiscount.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    label: {
      name: 'label',
      label: 'entities:ratioBookingDiscount.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    info: {
      name: 'info',
      label: 'entities:ratioBookingDiscount.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [],
    },
    mandatorySettings: {
      name: 'mandatorySettings',
      label: 'entities:ratioBookingDiscount.attributes.mandatorySettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingMandatorySettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioBookingDiscountModel
